// extracted by mini-css-extract-plugin
export default {"offer":"offer_offer__X7faP","container":"offer_container__FomSb","title":"offer_title__47TZo","galery":"offer_galery__zGHaO"};